import { Stack } from "@mui/material";
import SearchBar from "./SearchBar";
import DateFilter from "./DateFilter";
import StatusFilter from "./StatusFilter";
import ExportButton from "./ExportButton";
import Accountants from "../../Admin/Toolbar/Accountants";

export default function Toolbar({
  isLoading,
  countryId,
  countPending,
  countReparacion,
}) {
  return (
    <Stack
      mt={2}
      gap={2}
      direction="row"
      justifyContent="space-between"
      flexWrap="wrap"
    >
      <Stack direction="row" gap={2} alignItems="center" flexWrap="wrap">
        <SearchBar />
        <StatusFilter countryId={countryId} />
        <DateFilter />
        <ExportButton countryId={countryId} isLoading={isLoading} />
      </Stack>
      <Stack direction="row" gap={2} alignItems="center" flexWrap="wrap">
        <Accountants
          countPending={countPending}
          countReparacion={countReparacion}
        />
      </Stack>
    </Stack>
  );
}
